import { BodyM, HeadingL } from '@/components/Typography'
import type { TitleProps } from '@/models'

import MediaCard, { type MediaCardProps } from './MediaCard'
import { MediaCardList, MediaCardListHeader, MediaCardListSection } from './styles'

interface MediaCardListBlockProps {
  title?: TitleProps
  subtitle?: TitleProps
  cards?: MediaCardProps[]
}
const MediaCardListBlock = ({ title, subtitle, cards }: MediaCardListBlockProps) => (
  <MediaCardListSection>
    <MediaCardListHeader>
      {title && <HeadingL tag={title.tag || 'h3'}>{title.text}</HeadingL>}
      {subtitle && <BodyM tag={subtitle.tag || 'p'}>{subtitle.text}</BodyM>}
    </MediaCardListHeader>
    {cards && (
      <MediaCardList>
        {cards.length > 0 &&
          cards.map((card, index) => <MediaCard key={`mdl-card-${index}`} {...card} />)}
      </MediaCardList>
    )}
  </MediaCardListSection>
)
export default MediaCardListBlock
